"use client";

// مرز code-split سمت client: dynamic() فقط داخل کامپوننت client چانک جدا می‌سازد
// (از Server Component همه‌ی کد client صفحه‌ها در یک چانک مشترک می‌آمد).
import dynamic from "next/dynamic";
import LoadingAll from "@/components/LoadingAll";

const Component = dynamic(() => import("./_component"), {
  loading: () => <LoadingAll />,
});

export default Component;
